/* handles chat widget layout, css html like a template... */
import { ChatStyles } from './chat-styles.js';
export class ChatLayout {
  constructor(widget, root, logger) {
    this.widget = widget;
    this.root = root;
    this.logger = logger || console;
    this.stateUnsubscribers = [];
    this.naturalPopoverOpen = false;
    this.naturalPopoverPositionFrame = null;
    this.naturalPopoverListenersActive = false;
    this.handleNaturalPopoverViewportChange = () => {
      this.scheduleNaturalPopoverPosition();
    };
  }

  render() {
    this.root.innerHTML = `
        <style>${ChatStyles.get()}</style>
        <div class="engage" id="engage-message" part="engage-message-bubble">
          <div class="engage-icon" id="engage-icon"></div>
          <div class="engage-text" id="engage-text"></div>
          <button class="engage-close" id="engage-close" aria-label="Dismiss">
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>
        <div class="bubble" id="chat-toggle" part="bubble-container">
          <svg class="bubble-icon-open" viewBox="0 0 24 24" part="bubble-icon-open">
            <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
          </svg>
          <svg class="bubble-icon-close" viewBox="0 0 24 24" part="bubble-icon-close">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
          <div class="bubble-custom-content" id="bubble-custom-content" style="display: none;">
            <div class="bubble-custom-icon" id="bubble-custom-icon"></div>
            <div class="bubble-custom-text" id="bubble-custom-text"></div>
          </div>
        </div>

        <div class="chat-window" id="chat-window" part="chat-window-container">
          <div class="header" part="header-bar">
            <div class="header-title-container">
              <button id="back-btn" class="header-nav-btn" title="Back" aria-label="Back" style="display: none;">
                <svg viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
              </button>
              <span class="header-title" id="header-title"></span>
              <div class="connection-status" id="connection-status" title="Connection Status"></div>
            </div>
            <div class="header-controls">
              <button id="options-toggle-btn" title="Options">
                <svg viewBox="0 0 24 24"><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
              </button>
              <ul class="options-menu" id="options-menu" part="options-menu">
                <!--<li><button id="email-transcript-btn">Email Transcript</button></li>-->
                <div id="menu-suggestions-container"></div>
                <li class="menu-divider" id="menu-divider" style="display: none; border-top: 1px solid #eee; margin: 4px 0;"></li>
                <li id="copy-eval-item" style="display: none;"><button id="copy-eval-btn">Copy as Eval</button></li>
                <li id="end-chat-item"><button id="end-chat-btn">End Chat</button></li>
              </ul>
              <button id="header-close-btn" title="Close chat" aria-label="Close chat" style="display: none;">
                <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
              </button>
              <button id="mobile-close-btn" title="Close chat" aria-label="Close chat" class="mobile-only">
                <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
              </button>
            </div>
          </div>
          <div class="messages-container" id="messages-container" part="message-list">
            <div class="ai-status-indicator hidden" id="ai-status-indicator" part="ai-status-indicator">
              <svg viewBox="0 0 24 24">
                <path d="M12 4V1c.6 0 1.1.4 1.1.9v.1c0 .5-.5 1-1.1 1zm0 18v3c-.6 0-1.1-.4-1.1-1v-.1c0-.5.5-1 1.1-1zm8.5-8.5h3c.6 0 1.1-.4 1.1-1h-.1c0-.5-.4-1-1-1zm-17 0H1c-.6 0-1 .4-1 1h.1c0 .5.4 1 1 1zm15.1-6.7L22 4.9c.4-.4.4-1.1 0-1.5l-.1-.1c-.4-.4-1.1-.4-1.5 0zm-12.8 12.8L3 20.8c-.4.4-.4 1.1 0 1.5l.1.1c.4.4 1.1.4 1.5 0zm0-12.8L4.9 3.4c-.4-.4-1.1-.4-1.5 0l-.1.1c-.4.4-.4 1.1 0 1.5zm12.8 12.8l1.5 1.5c.4.4 1.1.4 1.5 0l.1-.1c.4-.4.4-1.1 0-1.5z"/>
              </svg>
              <span class="status-text">Thinking...</span>
           </div>
           <div class="typing-indicator hidden" id="typing-indicator" part="typing-indicator">
              <span></span><span></span><span></span>
          </div>
        </div>

        <div class="suggestion-buttons" id="suggestion-buttons" part="suggestion-buttons-area"></div>

        <div class="chat-input-area hidden" part="input-area-container">
          <input type="file" id="file-input" accept="image/*" multiple style="display: none;" />
          <button id="attach-button" title="Attach File" part="attach-button-element" style="display: none;">
            <svg viewBox="0 0 24 24"><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/></svg>
          </button>
          <input type="text" id="chat-input" placeholder="Type a message..." part="input-field-element" autocomplete="off" />
          <button id="send-button" title="Send Message" part="send-button-element">
            <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
          </button>
        </div>
      </div>
   `;
   this.updateStyles();
  }

  update() {
    this.updateStyles();
    this.updateBubbleIcon();
    this.updateEngageMessage();
    this.updateUIBasedOnState();
  }

  updateStyles() {
    this.widget.style.setProperty("--ctm-chat-primary-color-default", this.widget.config.chatPrimaryColor);
    this.widget.style.setProperty("--ctm-chat-primary-color-dark-default", this.widget.config.chatPrimaryColorDark);
    this.widget.style.setProperty("--ctm-chat-bubble-size-default", this.widget.config.chatBubbleSize);
    this.widget.style.setProperty("--ctm-chat-bubble-icon-size-default", this.widget.config.chatBubbleIconSize);
    this.widget.style.setProperty("--ctm-chat-window-width-default", this.widget.config.chatWindowWidth);
    this.widget.style.setProperty("--ctm-chat-height-width-default", this.widget.config.chatWindowHeight);
  }

  updateBubbleIcon() {
    const currentUrl = window.location.href;
    let iconText     = this.widget.config.iconText;
    let iconImage    = this.widget.config.iconImage;

    // Check conditional icon texts (already filtered by schedule on server)
    if (this.widget.config.iconTexts && Array.isArray(this.widget.config.iconTexts)) {
      for (const item of this.widget.config.iconTexts) {
        // Server has already filtered by schedule, only URL conditions remain
        if (
          !item.conditions ||
          item.conditions.length === 0 ||
          this.widget.evaluateConditions(item.conditions)
        ) {
          iconText = item.text;
          break;
        }
      }
    }

    // Check conditional icon images (already filtered by schedule on server)
    if (this.widget.config.iconImages && Array.isArray(this.widget.config.iconImages)) {
      for (const item of this.widget.config.iconImages) {
        // Server has already filtered by schedule, only URL conditions remain
        if (
          !item.conditions ||
          item.conditions.length === 0 ||
          this.widget.evaluateConditions(item.conditions)
        ) {
          iconImage = item.image;
          break;
        }
      }
    }

    // Update bubble display based on what's configured
    const bubbleOpenIcon = this.root.querySelector('.bubble-icon-open');
    const bubbleCloseIcon = this.root.querySelector('.bubble-icon-close');
    const customContent = this.root.getElementById('bubble-custom-content');
    const customIcon = this.root.getElementById('bubble-custom-icon');
    const customText = this.root.getElementById('bubble-custom-text');

    if (iconImage || iconText) {
      // Hide default icons, show custom content
      if (bubbleOpenIcon) bubbleOpenIcon.style.display = 'none';
      if (customContent) customContent.style.display = 'flex';
      
      // Add pill mode class if text is present
      if (iconText && this.widget.bubbleEl) {
        this.widget.bubbleEl.classList.add('pill-mode');
      }
      
      // Set custom icon if provided
      if (iconImage && customIcon) {
        if (iconImage.startsWith('<svg')) {
          // Direct SVG content
          customIcon.innerHTML = iconImage;
        } else if (iconImage.startsWith('data:') || iconImage.startsWith('http')) {
          // Image URL
          customIcon.innerHTML = `<img src="${iconImage}" />`;
        } else {
          // Assume it's an SVG path
          customIcon.innerHTML = `<svg viewBox="0 0 24 24">${iconImage}</svg>`;
        }
      } else if (iconText && customIcon) {
        // Use default chat icon if no custom image but text is present
        customIcon.innerHTML = `<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/></svg>`;
      } else if (customIcon) {
        // No text and no image - hide icon
        customIcon.style.display = 'none';
      }
      
      // Set custom text if provided
      if (iconText && customText) {
        customText.textContent = iconText;
        customText.style.display = 'block';
      } else if (customText) {
        customText.style.display = 'none';
      }
    } else {
      // Show default icons, hide custom content
      if (bubbleOpenIcon) bubbleOpenIcon.style.display = '';
      if (customContent) customContent.style.display = 'none';
      // Remove pill mode class
      if (this.widget.bubbleEl) {
        this.widget.bubbleEl.classList.remove('pill-mode');
      }
    }
  }

  updateEngageMessage() {
    // Get the default engage message and icon
    let engageMessage = this.widget.config.engageMessage;
    let engageIcon = this.widget.config.engageMessageIcon || null;

    // Check conditional engage messages (already filtered by schedule on server)
    // Client only evaluates URL conditions
    if (this.widget.config.engageMessages && Array.isArray(this.widget.config.engageMessages)) {
      let foundMatch = false;
      
      for (const item of this.widget.config.engageMessages) {
        // Server has already filtered by schedule, only URL conditions remain
        if (
          !item.conditions ||
          item.conditions.length === 0 ||
          this.widget.evaluateConditions(item.conditions)
        ) {
          engageMessage = item.message;
          engageIcon = item.icon || engageIcon; // Use item icon if available, otherwise keep default
          foundMatch = true;
          break;
        }
      }
      
      // If no conditional messages matched but we have conditionals, use the default
      // This is already set above, so no action needed
    }

    // Update engage message display
    if (this.widget.engageMessageEl && this.widget.engageTextEl) {
      this.widget.engageTextEl.textContent = engageMessage || '';
      
      if (engageIcon && this.widget.engageIconEl) {
        // Add has-icon class for enhanced styling
        this.widget.engageMessageEl.classList.add('has-icon');
        
        if (engageIcon.startsWith('<svg')) {
          // Direct SVG content
          this.widget.engageIconEl.innerHTML = engageIcon;
        } else if (engageIcon.startsWith('data:') || engageIcon.startsWith('http')) {
          // Image URL
          this.widget.engageIconEl.innerHTML = `<img src="${engageIcon}" />`;
        } else if (engageIcon.startsWith('<path')) {
          // Assume it's an SVG path
          this.widget.engageIconEl.innerHTML = `<svg viewBox="0 0 24 24">${engageIcon}</svg>`;
        } else {
          // For any other format, assume it's a full element
          this.widget.engageIconEl.innerHTML = engageIcon;
        }
      } else {
        // Remove has-icon class
        this.widget.engageMessageEl.classList.remove('has-icon');
        if (this.widget.engageIconEl) {
          this.widget.engageIconEl.innerHTML = '';
        }
      }
    }
  }

  updateUIBasedOnState() {
    const connectionStatus = this.widget.stateManager?.get('connectionStatus') || 'disconnected';
    const lazyConnectionReady = !!this.widget.stateManager?.get('lazyConnectionReady');
    const isConnected = connectionStatus === "connected";
    const isConnecting = connectionStatus === "connecting";
    const isEnded = connectionStatus === "ended";
    const chatWindowEl = this.widget.chatWindowEl || this.root.getElementById('chat-window');
    const aiEnabled = this.widget.stateManager?.get('aiEnabled');
    const waitingForAgent = !!this.widget.stateManager?.get('waitingForAgent');
    const allMessages = this.widget.messageHandler?.getMessages() || [];
    const hasFormMessage = allMessages.some(msg => msg.type === "form");
    const hasActiveConversation = typeof this.widget.hasActiveConversation === "function"
      ? this.widget.hasActiveConversation()
      : (this.widget.stateManager?.get('callId') || this.widget.stateManager?.get('waitingForAgent')) ||
        allMessages.some(msg => ["user", "ai", "agent"].includes(msg.type) || msg.role === "user" || msg.role === "assistant" || msg.twilioMessage);
    const isFormOnlyMode = hasFormMessage && !hasActiveConversation;
    chatWindowEl?.classList.toggle("form-only", isFormOnlyMode);

    // Delegate all input/send button state to updateInputState for consistency
    this.updateInputState();
    // Options button state
    if (this.widget.optionsToggleBtn) {
      // Check if the menu has any items to show (suggestions, End Chat, or Copy as Eval)
      const hasMenuSuggestions =
        typeof this.widget.hasRenderableMenuSuggestions === "function"
          ? this.widget.hasRenderableMenuSuggestions()
          : (this.widget.currentSuggestions && this.widget.currentSuggestions.length > 0);
      const copyEvalVisible = this.widget.copyEvalItemEl && this.widget.copyEvalItemEl.style.display !== "none";
      const hasMenuItems = hasMenuSuggestions || copyEvalVisible || hasActiveConversation;

      // Hide the ⋮ options menu if form-only mode or no menu items
      this.widget.optionsToggleBtn.style.display = (isFormOnlyMode || !hasMenuItems) ? "none" : "";
      this.widget.optionsToggleBtn.disabled = false;
      if (isFormOnlyMode || !hasMenuItems) this.widget.optionsMenuEl?.classList.remove("visible");
    }
    
    // Back control is form-only; close remains available from the header.
    if (this.widget.backBtnEl) {
      this.widget.backBtnEl.style.display = isFormOnlyMode ? "" : "none";
    }
    if (this.widget.headerCloseBtnEl) {
      this.widget.headerCloseBtnEl.style.display = "";
    }
    if (this.widget.mobileCloseBtn) {
      // Avoid duplicate close buttons on mobile when in form-only mode
      this.widget.mobileCloseBtn.style.display = isFormOnlyMode ? "none" : "";
    }
    
    // End Chat should only be shown when a chat session is actually active
    if (this.widget.endChatItemEl) {
      this.widget.endChatItemEl.style.display = hasActiveConversation ? "" : "none";
    }

    // Connection Status Indicator dot
    if (this.widget.connectionStatusEl) {
      const displayStatus =
        connectionStatus === "disconnected" && lazyConnectionReady
          ? "ready"
          : connectionStatus;
      this.widget.connectionStatusEl.classList.remove("connected", "connecting", "disconnected", "closed", "error", "ended", "ready");
      const statusClass = displayStatus === "error" ? "error" : displayStatus;
      this.widget.connectionStatusEl.classList.add(statusClass);

      // Tooltip text for the status dot
      let title = displayStatus === "ready"
        ? "Status: Ready"
        : `Status: ${connectionStatus.charAt(0).toUpperCase() + connectionStatus.slice(1)}`;
      const lastMessage = allMessages.length > 0 ? allMessages[allMessages.length - 1] : null;
      if (connectionStatus === "error" && lastMessage?.type === "system" && lastMessage.content.startsWith("Error:")) {
        title = lastMessage.content; // More specific error
      } else if (
        (connectionStatus === "disconnected" || connectionStatus === "closed") &&
        lastMessage?.type === "system" &&
        lastMessage.content.includes("disconnected")
      ) {
        title = lastMessage.content;
      } else if (connectionStatus === "error" && this.widget.reconnectAttempts > 0) {
        title += ` (Attempt ${this.widget.reconnectAttempts}/${this.widget.config.maxReconnectAttempts})`;
      }
      this.widget.connectionStatusEl.title = title;
    }

    // Hide suggestions once a conversation has started (AI or agent messages)
    if (this.widget.suggestionsContainerEl) {
      const callId = this.widget.stateManager?.get('callId');
      let shouldExpandSuggestions = false;
      const shouldHideSuggestions =
        callId || hasFormMessage || waitingForAgent || (hasActiveConversation && aiEnabled);
      if (shouldHideSuggestions) {
        this.widget.suggestionsContainerEl.style.display = "none"; // hide suggestions - conversation started
      } else {
        // Show suggestions only before conversation starts
        const visibleButtons = this.widget.suggestionsContainerEl.querySelectorAll("button").length;
        if (visibleButtons > 0) {
          this.widget.suggestionsContainerEl.style.display = "";
          const conversationalMessages = allMessages.filter(msg => !["system", "form"].includes(msg.type));
          shouldExpandSuggestions = conversationalMessages.length <= 1;
        } else {
          this.widget.suggestionsContainerEl.style.display = "none";
        }
      }
      if (chatWindowEl) {
        chatWindowEl.classList.toggle("suggestions-expanded", shouldExpandSuggestions);
      }
    }
  }

  updateAIStatusIndicator(status, forceHide = false) {
    if (!this.widget.aiStatusIndicatorEl || !this.widget.messagesContainerEl) return;

    const statusTextSpan = this.widget.aiStatusIndicatorEl.querySelector(".status-text");
    const svgIcon = this.widget.aiStatusIndicatorEl.querySelector("svg");

    if (forceHide || status === "idle" || status === "completed" || !status) {
      this.widget.aiStatusIndicatorEl.classList.add("hidden");
      this.widget.aiStatusIndicatorEl.remove(); // Remove from DOM when hidden
      return;
    }

    // Ensure it's appended if not already
    if (!this.widget.aiStatusIndicatorEl.parentNode) {
      this.widget.messagesContainerEl.appendChild(this.widget.aiStatusIndicatorEl);
    }
    this.widget.aiStatusIndicatorEl.classList.remove("hidden");
    this.widget.aiStatusIndicatorEl.classList.remove("thinking", "responding", "searching", "error", "incomplete"); // Clear previous states

    let text = "";
    let showSpinner = false;
    let statusClass = "";

    switch (status) {
      case "thinking":
        text = "Thinking...";
        showSpinner = true;
        statusClass = "thinking";
        break;
      case "responding":
        text = "Responding...";
        showSpinner = true;
        statusClass = "responding";
        break;
      case "searching_files":
      case "searching_web":
        text = "Searching...";
        showSpinner = true;
        statusClass = "searching";
        break;
      case "processing_tools":
        text = "Processing request...";
        showSpinner = true;
        statusClass = "processing";
        break;
      case "error":
        text = "Error occurred";
        showSpinner = false;
        statusClass = "error";
        break;
      case "incomplete":
        text = "Response incomplete";
        showSpinner = false;
        statusClass = "incomplete";
        break;
      default:
        text = status;
        break;
    }

    if (statusTextSpan) statusTextSpan.textContent = text;
    if (svgIcon) svgIcon.style.display = showSpinner ? "inline-block" : "none";
    if (statusClass) this.widget.aiStatusIndicatorEl.classList.add(statusClass);

    this.widget.scrollToBottom();
  }
  
  // Subscribe to state changes for reactive updates
  listenForStateChanges(stateManager) {
    // Listen for connection status changes
    const unsubscribeConnection = stateManager.subscribe('connectionStatus', () => {
      this.updateUIBasedOnState();
      this.updateInputState();
    });
    this.stateUnsubscribers.push(unsubscribeConnection);

    const unsubscribeLazyConnection = stateManager.subscribe('lazyConnectionReady', () => {
      this.updateUIBasedOnState();
      this.updateInputState();
    });
    this.stateUnsubscribers.push(unsubscribeLazyConnection);
    
    // Listen for AI enabled state changes
    const unsubscribeAI = stateManager.subscribe('aiEnabled', () => {
      this.updateUIBasedOnState();
      this.updateInputState();
    });
    this.stateUnsubscribers.push(unsubscribeAI);
    
    // Listen for call ID changes
    const unsubscribeCallId = stateManager.subscribe('callId', () => {
      this.updateUIBasedOnState();
    });
    this.stateUnsubscribers.push(unsubscribeCallId);
    
    // Listen for waiting for agent changes
    const unsubscribeWaiting = stateManager.subscribe('waitingForAgent', () => {
      this.updateUIBasedOnState();
      this.updateInputState();
    });
    this.stateUnsubscribers.push(unsubscribeWaiting);
    
    // Listen for attachments enabled state changes
    const unsubscribeAttachments = stateManager.subscribe('attachmentsEnabled', (enabled) => {
      this.setAttachmentButtonVisibility(enabled);
    });
    this.stateUnsubscribers.push(unsubscribeAttachments);
  }
  
  // Clean up subscriptions
  cleanup() {
    this.teardownNaturalPopover();
    this.stateUnsubscribers.forEach(unsubscribe => unsubscribe());
    this.stateUnsubscribers = [];
  }
  
  // UI Management Methods moved from ChatWidget
  
  updateInputState() {
    const inputArea = this.root.querySelector('.chat-input-area');
    const inputEl = this.root.getElementById('chat-input');
    const sendBtnEl = this.root.getElementById('send-button');
    const chatWindowEl = this.root.getElementById('chat-window');
    
    const connectionStatus = this.widget.stateManager.get('connectionStatus');
    const isConnected = connectionStatus === "connected";
    const isEnded = connectionStatus === "ended";
    const lazyConnectionReady = !!this.widget.stateManager.get('lazyConnectionReady');
    const aiEnabled = this.widget.stateManager.get('aiEnabled');
    const hasActiveCall = !!this.widget.stateManager.get('callId');
    const waitingForAgent = !!this.widget.stateManager.get('waitingForAgent');
    const visibleSuggestionButtons =
      this.widget.suggestionsContainerEl?.querySelectorAll("button").length || 0;
    const hasRenderableSuggestions =
      typeof this.widget.hasRenderableMenuSuggestions === "function"
        ? this.widget.hasRenderableMenuSuggestions()
        : visibleSuggestionButtons > 0;
    const hasSuggestions = hasRenderableSuggestions || visibleSuggestionButtons > 0;
    const allowFreeText = !aiEnabled && !hasActiveCall && !waitingForAgent && !hasSuggestions;
    // Input should be usable if we're connected, not waiting,
    // and either AI is enabled OR we are in a live-agent call
    // Also allow input when ended so user can resume — but only if AI is available
    // If AI is disabled and there are no suggestions, allow free-text input
    const canResumeWithText = isEnded && aiEnabled;
    const canStartLazily =
      lazyConnectionReady &&
      !waitingForAgent &&
      !hasActiveCall &&
      !isEnded &&
      (aiEnabled || allowFreeText);
    const canType =
      (isConnected && !waitingForAgent && (aiEnabled || hasActiveCall || allowFreeText)) ||
      canResumeWithText ||
      canStartLazily;

    if (inputEl) {
      inputEl.disabled = !canType;
      // Set appropriate placeholder based on state
      if (canResumeWithText) {
        inputEl.placeholder = "Start a new chat...";
      } else if (!isConnected && !canStartLazily) {
        inputEl.placeholder = "Connecting...";
      } else if (waitingForAgent) {
        inputEl.placeholder = "Connecting you to an agent...";
      } else if (hasActiveCall && !aiEnabled) {
        inputEl.placeholder = "Type your message to the agent...";
      } else if (aiEnabled || allowFreeText) {
        inputEl.placeholder = "Type your message...";
      } else {
        inputEl.placeholder = "Please select a suggestion to start";
      }
    }
 
    // Hide input only when neither AI nor a live-agent session is active
    // Show input when chat has ended only if AI is available to resume
    if (inputArea) {
      if (!aiEnabled && !hasActiveCall && !canResumeWithText && hasSuggestions) {
        inputArea.classList.add('hidden');
        chatWindowEl?.classList.add('input-hidden');
      } else {
        inputArea.classList.remove('hidden');
        chatWindowEl?.classList.remove('input-hidden');
      }
    }
    
    // Update send button state - allow sending when ended to start new chat
    if (sendBtnEl && inputEl) {
      const isEmpty = inputEl.value?.trim().length === 0;
      const canSend =
        (this.widget.stateManager.isConnected() &&
          !waitingForAgent &&
          (aiEnabled || hasActiveCall || allowFreeText)) ||
        canResumeWithText ||
        canStartLazily;
      sendBtnEl.disabled = isEmpty || !canSend;
    }

    this.logger.debug('[CTM Chat] updateInputState', {
      connectionStatus, lazyConnectionReady, aiEnabled, hasSuggestions, allowFreeText, canType, isEnded,
      hasActiveCall, waitingForAgent, canResumeWithText,
      inputHidden: inputArea?.classList?.contains('hidden') || false,
      currentSuggestions: this.widget.currentSuggestions?.length,
      domButtons: visibleSuggestionButtons
    });

    this.adjustWindowHeight(); // Recalculate height when input visibility changes
  }
  
  scrollToBottom() {
    requestAnimationFrame(() => {
      const messagesContainerEl = this.root.getElementById('messages-container');
      if (messagesContainerEl) {
        // A start-button form belongs with its welcome message, not the
        // bottom of the (potentially much taller) embedded form.
        messagesContainerEl.scrollTop = this.widget.isFormOnlyMode?.()
          ? 0
          : messagesContainerEl.scrollHeight;
      }
    });
  }

  syncChatWindowLayer(isOpen) {
    const chatWindowEl = this.root.getElementById('chat-window');
    const canUsePopover =
      this.widget.isNaturalPlacement?.() &&
      typeof chatWindowEl?.showPopover === 'function' &&
      typeof chatWindowEl?.hidePopover === 'function';

    if (!canUsePopover) {
      if (this.naturalPopoverOpen || chatWindowEl?.hasAttribute('popover')) {
        this.teardownNaturalPopover();
      }
      return false;
    }

    if (!isOpen) {
      this.teardownNaturalPopover();
      return false;
    }

    if (this.naturalPopoverOpen) {
      this.positionNaturalPopover();
      return true;
    }

    chatWindowEl.setAttribute('popover', 'manual');
    chatWindowEl.style.visibility = 'hidden';

    try {
      chatWindowEl.showPopover();
      this.naturalPopoverOpen = true;
      this.positionNaturalPopover();
      chatWindowEl.style.visibility = '';
      this.startNaturalPopoverPositionTracking();
      return true;
    } catch (error) {
      chatWindowEl.style.visibility = '';
      chatWindowEl.removeAttribute('popover');
      this.naturalPopoverOpen = false;
      this.logger.debug('[CTM Chat] Falling back to nested natural placement', error);
      return false;
    }
  }

  positionNaturalPopover() {
    if (!this.naturalPopoverOpen) return;

    const chatWindowEl = this.root.getElementById('chat-window');
    const bubbleEl = this.widget.bubbleEl || this.root.getElementById('chat-toggle');
    if (!chatWindowEl || !bubbleEl) return;

    const bubbleRect = bubbleEl.getBoundingClientRect();
    const chatRect = chatWindowEl.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const gutter = 16;
    const preferredLeft = bubbleRect.right - chatRect.width;
    const preferredTop = bubbleRect.top - 12 - chatRect.height;
    const maxLeft = Math.max(gutter, viewportWidth - chatRect.width - gutter);
    const maxTop = Math.max(gutter, viewportHeight - chatRect.height - gutter);
    const left = Math.min(Math.max(gutter, preferredLeft), maxLeft);
    const top = Math.min(Math.max(gutter, preferredTop), maxTop);

    chatWindowEl.style.position = 'fixed';
    chatWindowEl.style.inset = 'auto';
    chatWindowEl.style.right = 'auto';
    chatWindowEl.style.bottom = 'auto';
    chatWindowEl.style.left = `${Math.round(left)}px`;
    chatWindowEl.style.top = `${Math.round(top)}px`;
    chatWindowEl.style.margin = '0';
  }

  scheduleNaturalPopoverPosition() {
    if (!this.naturalPopoverOpen || this.naturalPopoverPositionFrame) return;

    this.naturalPopoverPositionFrame = requestAnimationFrame(() => {
      this.naturalPopoverPositionFrame = null;
      this.positionNaturalPopover();
    });
  }

  startNaturalPopoverPositionTracking() {
    if (this.naturalPopoverListenersActive) return;

    window.addEventListener('resize', this.handleNaturalPopoverViewportChange);
    window.addEventListener(
      'scroll',
      this.handleNaturalPopoverViewportChange,
      true
    );
    this.naturalPopoverListenersActive = true;
  }

  teardownNaturalPopover() {
    const chatWindowEl = this.root.getElementById('chat-window');

    if (this.naturalPopoverListenersActive) {
      window.removeEventListener('resize', this.handleNaturalPopoverViewportChange);
      window.removeEventListener(
        'scroll',
        this.handleNaturalPopoverViewportChange,
        true
      );
      this.naturalPopoverListenersActive = false;
    }

    if (this.naturalPopoverPositionFrame) {
      cancelAnimationFrame(this.naturalPopoverPositionFrame);
      this.naturalPopoverPositionFrame = null;
    }

    if (this.naturalPopoverOpen && typeof chatWindowEl?.hidePopover === 'function') {
      try {
        chatWindowEl.hidePopover();
      } catch (error) {
        this.logger.debug('[CTM Chat] Natural popover was already closed', error);
      }
    }

    this.naturalPopoverOpen = false;
    if (!chatWindowEl) return;

    chatWindowEl.removeAttribute('popover');
    chatWindowEl.style.position = '';
    chatWindowEl.style.inset = '';
    chatWindowEl.style.right = '';
    chatWindowEl.style.bottom = '';
    chatWindowEl.style.left = '';
    chatWindowEl.style.top = '';
    chatWindowEl.style.margin = '';
    chatWindowEl.style.visibility = '';
  }
  
  adjustWindowHeight() {
    const chatWindowEl = this.root.getElementById('chat-window');
    const isOpen = this.widget.stateManager.get('isOpen');
    
    if (!chatWindowEl || !isOpen) return;

    if (this.widget.isPositionedPlacement?.()) {
      chatWindowEl.style.height = "";
      return;
    }
    
    chatWindowEl.style.height = `100dvh`;
  }
  
  updateHeaderText(text) {
    const headerTitleEl = this.root.getElementById('header-title');
    if (headerTitleEl) {
      headerTitleEl.textContent = text;
    }
  }
  
  hideEngageMessage() {
    const engageMessageEl = this.root.getElementById('engage-message');
    if (engageMessageEl) {
      engageMessageEl.classList.remove("visible");
      setTimeout(() => {
        engageMessageEl.style.pointerEvents = "none";
      }, 400); // After transition completes
    }
  }
  
  showEngageMessage() {
    const engageMessageEl = this.root.getElementById('engage-message');
    if (engageMessageEl && !this.widget.stateManager.get('engageMessageDismissed')) {
      engageMessageEl.style.pointerEvents = "auto";
      engageMessageEl.classList.add("visible");
      // Track engagement display
      if (this.widget.gtmTracker) {
        this.widget.gtmTracker.trackEngagement('displayed');
      }
    }
  }
  
  focusInput() {
    const inputEl = this.root.getElementById('chat-input');
    if (inputEl) {
      inputEl.focus();
    }
  }
  
  clearInput() {
    const inputEl = this.root.getElementById('chat-input');
    if (inputEl) {
      inputEl.value = "";
    }
  }
  
  getInputValue() {
    const inputEl = this.root.getElementById('chat-input');
    return inputEl ? inputEl.value.trim() : "";
  }
  
  setAttachmentButtonVisibility(visible) {
    const attachBtnEl = this.root.getElementById('attach-button');
    if (attachBtnEl) {
      attachBtnEl.style.display = visible ? "block" : "none";
    }
  }
}
